/**
 * Comutatorul ecranului „care clase" de pe activitatea practica (SP-05a).
 *
 * OPRIT implicit, si citit o SINGURA data, aici: `VITE_*` se inline-uieste la BUILD, deci
 * valoarea nu se schimba la runtime — un `if` imprastiat prin componente ar sugera altceva.
 *
 * 🔴 CU FLAGUL OPRIT, CALEA ACTIVITATII PRACTICE E CEA DE AZI, IN INTREGIME — nu doar ecranul
 * ascuns. Toate cele cinci puncte atinse din `use-lesson-completion.ts` (plafonul din
 * `NEXT_SLIDE`, pastrarea raspunsului la trecere, `isLastSlide`, `canGoNext`, momentul
 * trimiterii) trec prin `esteActivitatePracticaCuClase(...)`, deci cu flagul oprit sunt toate
 * false si ultimul slide real trimite si incheie, exact ca inainte. Ascunderea doar a ecranului
 * ar fi lasat trimiterea mutata — adica partea riscanta livrata fara comutator.
 *
 * De ce conteaza acum: owner-ul a pornit `LESSONS_PUNCTARE_PE_CLASE_ENABLED` in PROD
 * (2026-09-06), deci la aprobare punctajul e real (`50 x clase`). Flagul asta desparte
 * LIVRAREA de EXPUNERE — acelasi tipar ca `VITE_AUTENTIFICARE_COD` (SP-01) si
 * `VITE_PAS_VIDEO_INSCRIERE` (SP-03).
 *
 * ⚠️ Scris EXACT asa, fara cast si fara acces indirect: Vite inlocuieste TEXTUAL
 * `import.meta.env.VITE_...` la build. Varianta „curata" `(import.meta as {...}).env?.VITE_...`
 * multumeste TypeScript, dar nu se mai potriveste la inlocuire — in bundle ramane `undefined`,
 * flagul e mereu oprit, si numele variabilei nici macar nu apare in bundle. S-a intamplat deja
 * la `VITE_PAS_VIDEO_INSCRIERE`.
 */
export const PAS_CLASE_ACTIV =
    String(import.meta.env.VITE_PAS_CLASE_ACTIVITATE ?? '').toLowerCase() === 'true';

/**
 * Singurul loc in care se decide daca fluxul de clase e activ pentru o lectie.
 *
 * Se cheama si din reducer (functie pura, in afara hook-ului), si din hook — de aceea sta aici,
 * nu in vreunul din ele: doi predicati care trebuie sa fie mereu egali sunt un bug care asteapta.
 */
export function esteActivitatePracticaCuClase(tipLectie: string | undefined | null): boolean {
    return PAS_CLASE_ACTIV && tipLectie === 'PRACTICAL_ACTIVITY';
}
